/* One owner for scroll visibility, preview offset and the content-page footer boundary.
 * The Inbox conversation is never closed or moved: only its public activator part is
 * hidden by CSS while the footer supplies the normal contact/navigation routes. */
(() => {
  const wrapper = document.getElementById('scrollToTopBtn');
  if (!wrapper || wrapper.dataset.inventaFloatingBound) return;
  wrapper.dataset.inventaFloatingBound = 'true';

  const contentPage = document.body.hasAttribute('data-inventa-content-page');
  let footerVisible = false;
  let previewBar;
  let footer;

  const updateVisibility = () => {
    wrapper.hidden = window.scrollY <= 400 || (contentPage && footerVisible);
    document.body.toggleAttribute('data-inventa-footer-visible', contentPage && footerVisible);
  };
  const updatePreviewOffset = () => {
    const height = previewBar ? previewBar.getBoundingClientRect().height : 0;
    wrapper.style.transform = height > 0 ? `translateY(-${Math.ceil(height)}px)` : '';
  };
  const previewResize = new ResizeObserver(updatePreviewOffset);
  const findPreviewBar = () => {
    const next = document.getElementById('PBarNextFrameWrapper');
    if (next === previewBar) return;
    previewResize.disconnect();
    previewBar = next;
    if (previewBar) previewResize.observe(previewBar);
    updatePreviewOffset();
  };

  const footerObserver = contentPage && 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.target === footer) footerVisible = entry.isIntersecting;
      }
      updateVisibility();
    }) : null;
  const findFooter = () => {
    if (!footerObserver) return;
    const next = document.querySelector('footer.shopify-section--footer');
    if (next === footer) return;
    footerObserver.disconnect();
    footer = next;
    footerVisible = false;
    if (footer) footerObserver.observe(footer);
    updateVisibility();
  };

  new MutationObserver(findPreviewBar).observe(document.body, {childList: true});
  document.addEventListener('shopify:section:load', findFooter);
  document.addEventListener('shopify:section:unload', findFooter);
  wrapper.querySelector('button').addEventListener('click', () => {
    window.scrollTo({top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
  window.addEventListener('scroll', updateVisibility, {passive: true});
  window.addEventListener('pageshow', () => {
    findPreviewBar();
    findFooter();
    updateVisibility();
  });
  findPreviewBar();
  findFooter();
  updateVisibility();
})();
